import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "row g-0 align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/avatars/avatar.png",
    class: "img-fluid rounded-circle d-block mx-auto",
    alt: "avatar",
    width: "48"
  })
], -1)
const _hoisted_5 = { class: "col-9" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "card-text text-muted" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right fs-2x" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.list.length > 0)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createElementVNode("div", {
          class: "card mb-3 transparente",
          onClick: ($event: any) => (_ctx.onItemTap(item))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h5", _hoisted_7, _toDisplayString([item.nombre, item.apellidos].join(" ")), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("fechaNacimientoMenorListLabel")) + " " + _toDisplayString(_ctx.format(item.fechaNacimiento, "dd/MM/yyyy")), 1)
              ])
            ]),
            _hoisted_9
          ])
        ], 8, _hoisted_2),
        _hoisted_10
      ], 64))
    }), 128))
  ], 64))
}